<template>
  <span v-if="!edit" class="text-sm">
    {{ formatValue() }}
  </span>

  <NumberAnswer v-else v-bind="$attrs" no-label :question="original" />
</template>

<script>

import NumberAnswer from '#views/questionnaire/answers/NumberAnswer';
import {localeNumber} from "#functions/formatter.js";

export default {
  name: "NumberDetail",
  inheritAttrs: false,
  components: {
    NumberAnswer
  },
  props: {
    value: {
      required: true,
    },
    edit: {
      type: Boolean,
      required: true,
    },
    original: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatValue(){
      if(!this.value || this.value === '') return 'Sem resposta';
      const val = localeNumber(this.value);
      return val ?? 'Sem resposta';
    }
  },
  mounted(){
    this.$emit("update:modelValue", this.value);
  },
  watch: {
    value(newer){
      this.$emit("update:modelValue", newer);
    }
  }
};
</script>
